import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import { Box, TableCell, Tooltip } from "@mui/material";
import { STALLED_COLOR } from "./constants";
import { formatRelativeTime } from "./formatRelativeTime";
import { formatTimestamp } from "./formatTimestamp";
import type { ProjectLidarUploadStatus } from "./schemas";
import { stalledDays } from "./stalled";
import t from "./translations";
import useNow from "./useNow";

type Props = {
  projectStatus: ProjectLidarUploadStatus;
  reference: string;
};

export default function SinceCell({ projectStatus, reference }: Props) {
  const now = useNow();
  const reachedAt = projectStatus.status_reached_at;
  if (!reachedAt) {
    return <TableCell>{t.NoTimestamp}</TableCell>;
  }

  const daysStalled = stalledDays(projectStatus, now);
  const tooltipLines = [
    formatTimestamp(reachedAt),
    daysStalled === null ? null : t.StalledFor(daysStalled),
  ].filter((line): line is string => line !== null);

  return (
    <TableCell sx={{ whiteSpace: "nowrap" }}>
      <Tooltip
        title={tooltipLines.map((line) => <div key={line}>{line}</div>)}
        arrow
      >
        <Box
          data-testid={`lidar-upload-status.since.${reference}`}
          sx={{ display: "flex", alignItems: "center", gap: 0.5 }}
        >
          {daysStalled !== null && (
            <WarningAmberIcon
              data-testid={`lidar-upload-status.stalled.${reference}`}
              fontSize="small"
              sx={{ color: STALLED_COLOR }}
            />
          )}
          {formatRelativeTime(new Date(reachedAt), now)}
        </Box>
      </Tooltip>
    </TableCell>
  );
}
